import React from 'react';
import { FaHeart, FaGithub, FaLinkedin, FaTwitter, FaCode } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full py-16 px-6 sm:px-12 md:px-24 border-t border-slate-900 bg-navy-deep relative overflow-hidden">
      {/* Decorative gradient */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[80%] h-[1px] bg-gradient-to-r from-transparent via-accent-primary to-transparent opacity-30 shadow-[0_0_20px_rgba(0,245,212,0.5)]" />
      
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8 z-10 relative">
        {/* Branding */}
        <div className="flex flex-col gap-3 text-center md:text-left">
           <h2 className="text-2xl font-display font-bold text-white tracking-tighter">
             <span className="text-accent-primary">Yash</span>
             <span className="text-white">Patel</span>
           </h2>
           <p className="text-slate-500 font-mono text-xs uppercase tracking-widest leading-relaxed">
             Empowering brands through modern<br/>digital experiences.
           </p>
        </div>

        {/* Social Links */}
        <div className="flex items-center gap-6">
           {[FaGithub, FaLinkedin, FaTwitter, FaCode].map((Icon, idx) => (
             <motion.a 
               key={idx} 
               href="#" 
               target="_blank" 
               rel="noreferrer" 
               whileHover={{ y: -5, scale: 1.1 }}
               className="text-slate-400 text-xl hover:text-accent-primary transition-colors p-2 glass rounded-xl border border-transparent hover:border-slate-800"
             >
               <Icon />
             </motion.a>
           ))}
        </div>

        {/* Copyright */}
        <div className="flex flex-col items-center md:items-end gap-2 text-center md:text-right">
           <p className="text-slate-500 text-xs font-mono uppercase tracking-[0.2em]">
             &copy; {currentYear} All Rights Reserved
           </p>
           <p className="text-slate-400 text-sm font-medium flex items-center gap-2 mt-1">
             Designed & Built with <FaHeart className="text-red-500 animate-pulse" /> by <span className="text-accent-primary font-bold">Yash Patel</span>
           </p>
        </div>
      </div>
      
      {/* Background radial glow */}
      <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-accent-primary/5 blur-[100px] rounded-full" />
      <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-accent-purple/5 blur-[100px] rounded-full" />
    </footer>
  );
};

export default Footer;
